import { z } from 'zod';

export const schema = z.object({
  noticeNarrative: z.string(),
});

export const strictSchema = z.object({
  noticeNarrative: z.string().min(1, 'Enter the notice narrative.'),
});
